// eslint-disable-next-line
(function (app) {
    // eslint-disable-next-line
    if (app.location && location.search.indexOf('saute') >= 0) {
        window.strix = window.strix || {};
        window.strix.saute = true;
    }
}(window));
